import React from 'react'
import useListKeyboardInteraction from 'Hooks/useListKeyboardInteraction'
import { Row } from 'react-styled-flexboxgrid-tmp'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import format from 'date-fns/format'
import cn from 'comma-number'
import { _Container, _ListCount, _ListingList, _TitleRow, _Listing } from './styles'

const NewListingsList = ({ list, sectionTitle }) => {
  useListKeyboardInteraction({
    enableKeyboardInteraction: true,
    parentClassName: `.${_ListingList.styledComponentId}`,
    childClassName: `.${_Listing.styledComponentId} a`,
  })

  return (
    <_Container>
      <h2>{sectionTitle} <_ListCount>{list.length}</_ListCount></h2>
      <Row>
        <_ListingList>
          <_TitleRow>
            <span>Address</span>
            <span className="bedBathCol">Beds | Baths</span>
            <span className="priceCol">Price</span>
            <span>Date Added</span>
          </_TitleRow>
          {
            list && list.map(listing => (
              <_Listing>
                <Link to={'/' + listing.url}>
                  <span>
                    {listing.title}, {listing.locality_name}, {listing.province_name}
                    <span> {listing.subtitle || ''}</span>
                  </span>

                  <span className="bedBathCol">
                    {listing.bed_type || '-'} {listing.bedrooms ? 'beds' : ''} | {listing.bathrooms || '-'} baths
                  </span>

                  <span className="priceCol">${cn(listing.asking_price)}</span>
                  <span>
                    {listing.entry_date ? format(new Date(listing.entry_date?.replace(/-/g, '/')), 'MMM d, yyyy') : ''}
                  </span>

                </Link>
              </_Listing>
            ))
          }
        </_ListingList>
      </Row>
    </_Container>
  )
}

NewListingsList.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape({})),
  sectionTitle: PropTypes.string,
}

export default NewListingsList
